import { Chip } from '@mui/material'
import shared from '@/components/Settings/settingsShared.module.scss'

export default function UsersTableStatusChip({ status }) {
  const chipClass = status.color === 'default' ? `${shared.chip} ${shared.chipDefault}` : shared.chip
  return (
    <Chip label={status.label} color={status.color} size="small" variant="outlined" className={chipClass} />
  )
}
